import {
  Box,
  Image,
  Heading,
  Text,
  Stack,
  Button,
  Flex,
} from "@chakra-ui/react";
import caseStudies from "../Data/caseStudies.json";
import { useNavigate } from "react-router-dom";

export interface CaseStudyCardProps {
  id: string;
  mode?: "light" | "dark"; // allow parent to control theme
}

export const CaseStudyCard: React.FC<CaseStudyCardProps> = ({ id, mode = "light" }) => {
  const navigate = useNavigate();
  const study = caseStudies.find((s) => s.id === id);
  if (!study) return null;

  const {
    title,
    subtitle,
    description,
    imageFile,
    tenantLogoFile,
    buttonText,
  } = study;

  const bg = mode === "dark" ? "gray.800" : "white";
  const textColor = mode === "dark" ? "gray.100" : "gray.800";
  const subtitleColor = mode === "dark" ? "gray.300" : "gray.500";
  const descriptionColor = mode === "dark" ? "gray.200" : "gray.600";

  return (
    <Box
      maxW="sm"
      borderWidth="1px"
      borderRadius="xl"
      overflow="hidden"
      bg={bg}
      boxShadow="lg"
      _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
      transition="all 0.2s ease-in-out"
    >
      <Box position="relative" w="100%" h="200px">
        <Image src={imageFile} alt={title} objectFit="cover" w="100%" h="100%" />
        {tenantLogoFile && (
          <Flex
            position="absolute"
            top="10px"
            left="10px"
            bg="white"
            borderRadius="md"
            p={1}
            boxShadow="md"
            align="center"
            justify="center"
          >
            <Image src={tenantLogoFile} alt={`${title} logo`} h="40px" objectFit="contain" />
          </Flex>
        )}
      </Box>

      <Stack spacing={3} p={5}>
        <Heading size="md" color={textColor}>{title}</Heading>
        {subtitle && (
          <Text fontSize="sm" fontWeight="semibold" color={subtitleColor}>
            {subtitle}
          </Text>
        )}
        <Text fontSize="sm" color={descriptionColor}>{description}</Text>

        {buttonText && (
          <Button
            as="a"
            onClick={() => navigate(`/technologies/case-study-details/${id}`)}
            size="sm"
            colorScheme={mode === "dark" ? "teal" : "blue"}
            variant="solid"
            alignSelf="start"
          >
            {buttonText}
          </Button>
        )}
      </Stack>
    </Box>
  );
};
